<div>
  &nbsp;
  @if (inInventory) {
    <a uiSref="a.material.inventory.create"
      title="Artikel Einpflegen"
      class="btn btn-default"
      >
      <span class="fa fa-plus"></span>
    </a>
  }

  @if (!!variation && !!article) {
    <a class="btn btn-default" (click)="openModal()">
      Wareneingang einbuchen
    </a>
  }

  @if (('material.order.create'|HasPerm)) {
    <a class="btn btn-default"
      uiSref="a.material.order.create"
      target="_blank"
      [uiParams]="{supplier_id: $safeNavigationMigration(article?.supplier_id), marked_variation_id: $safeNavigationMigration(variation?.id)}"
      >
      <i class="fa fa-truck"></i>&nbsp;Material bestellen
    </a>
  }
</div>
